import { mergeIconColorVars as e } from "../icon-props.js";
import { jsx as t } from "react/jsx-runtime";
//#region src/icons/omega.tsx
function n({ colors: n, style: r, ...i }) {
	return /* @__PURE__ */ t("svg", {
		viewBox: "0 0 24 24",
		fill: "none",
		"aria-hidden": "true",
		focusable: "false",
		xmlns: "http://www.w3.org/2000/svg",
		style: {
			...e(n),
			...r
		},
		...i,
		children: /* @__PURE__ */ t("path", {
			d: "M20.8011 19.5536H17.1082C17.7332 19.1679 18.3082 18.7143 18.8332 18.1928C24.8377 12.2356 20.4632 1.97592 12.0009 2.00004C3.53671 1.97917 -0.837574 12.2351 5.17259 18.1965C5.69391 18.7143 6.2689 19.1679 6.8939 19.5536H3.20104C1.59 19.5986 1.5766 21.9469 3.20107 22H8.31806C9.4335 22 10.3655 21.479 10.6331 19.9714C10.733 19.4083 10.5231 18.4402 9.10633 17.9143C2.14468 15.0177 4.47179 4.43808 12.0009 4.33663C19.7099 4.46543 21.8087 15.2417 14.5717 17.9143C13.6886 18.2213 13.341 19.281 13.3455 19.9714C13.3526 21.0893 14.3962 22 15.5176 22L20.8011 22C22.4124 21.9633 22.4195 19.5972 20.8011 19.5536Z",
			fill: "var(--icon-color-primary, currentColor)"
		})
	});
}
//#endregion
export { n as OmegaIcon };
